import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/knowledge/mocker'

export default {
  receivedKnowledgesInfiniteLoading (searchParams) {
    if (isMock) return generator(mocker.knowledge())
    return instance().get(endpoint + '/knowledge', { params: searchParams })
  }
}



// WEBPACK FOOTER //
// ./src/api/knowledge/index.js